import { render, staticRenderFns } from "./businessAlliance.vue?vue&type=template&id=38ef1384&scoped=true&"
import script from "./businessAlliance.vue?vue&type=script&lang=ts&"
export * from "./businessAlliance.vue?vue&type=script&lang=ts&"
import style0 from "./businessAlliance.vue?vue&type=style&index=0&id=38ef1384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef1384",
  null
  
)

export default component.exports